import { render, staticRenderFns } from "./NavUser.vue?vue&type=template&id=5378e03e&scoped=true"
import script from "./NavUser.vue?vue&type=script&lang=js"
export * from "./NavUser.vue?vue&type=script&lang=js"
import style0 from "./NavUser.vue?vue&type=style&index=0&id=5378e03e&prod&lang=scss&scoped=true"
import style1 from "./NavUser.vue?vue&type=style&index=1&id=5378e03e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5378e03e",
  null
  
)

export default component.exports